import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { CTA, Modal, NoResult, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import routes from '../../../../routes';
import {
  getLabelByType,
  getUrlFromNotification,
  replaceCourseSubstrings,
} from '../../../../utils/notifications';
import { NOTIFICATION_READ } from '../../../../app/redux/actions/notifications';
import {
  NotificationContent,
  NotificationDescription,
  NotificationLabel,
  Status,
} from './style';

export const ModalNotificationsId = 'ModalNotifications';

const ModalNotifications = ({
  notifications,
  modalClose,
  readNotification,
}) => {
  const scrollableAreaRef = useRef(null);
  const navigate = useNavigate();

  const handleOnClickNotifcation = (item) => {
    if (item.status === 0) readNotification({ ids: [item.id], status: 1 });
    const url = getUrlFromNotification(item);
    navigate(url);
    modalClose();
  };

  return (
    <Modal
      title="Notifiche"
      modalId={ModalNotificationsId}
      scrollableAreaRef={scrollableAreaRef}
      forceFullscreen
    >
      <ScrollableArea ref={scrollableAreaRef} className="pl-0 pr-0">
        {notifications?.length > 0 ? (
          <NotificationContent>
            {(notifications || []).slice(0, 5).map((itemNotification) => (
              <NotificationDescription
                key={`notification--${itemNotification?.id}`}
                notRead={itemNotification.status === 0}
                onClick={() => handleOnClickNotifcation(itemNotification)}
              >
                <div className="info-wrapper">
                  {itemNotification.status === 0 && <Status />}
                  <Text type="h3" className="action">
                    {getLabelByType(itemNotification)}:
                  </Text>
                  <Text type="b4" className="date" mb={0}>
                    {dayjs(
                      new Date((itemNotification?.created || 0) * 1000)
                    ).format('DD/MM/YYYY')}
                  </Text>
                </div>
                <NotificationLabel>
                  <Text type="h3">{itemNotification?.title}</Text>
                  <Text type="b4">
                    {replaceCourseSubstrings({ input: itemNotification?.body })}
                  </Text>
                </NotificationLabel>
              </NotificationDescription>
            ))}
          </NotificationContent>
        ) : (
          <NoResult text="Non ci sono notifiche" />
        )}
      </ScrollableArea>
      <Footer>
        <CTA
          type="primary"
          btnText="tutte le notifiche"
          fullsize
          onClick={() => {
            navigate(routes.notifications.path);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalNotifications.propTypes = {
  //HOC: withMediaQueries

  // state
  notifications: PropTypes.array,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  readNotification: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { headerNotification: notifications } = state.notifications;
      return { notifications };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      readNotification: ({ ids, status }) =>
        dispatch({ type: NOTIFICATION_READ._REQUEST, ids, status }),
    })
  ),
  withMediaQueries
)(ModalNotifications);
